import React, { useEffect, useState } from "react";
import Loader from "../../UI/loader";

import { connect } from "react-redux";
import moment from "moment";
import { withTranslation } from "react-i18next";
import { sendAnalytics } from "../../../action/homeAction";
import { setRegPage } from "../../../action/action";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { CLICKED, CMSPath, EXIT } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import { dateFormatHandler } from "../../../JS/dateFormatHandler";
import MiniLoader from "../../UI/MiniLoader";
import { scrollToTop } from "../../../JS/scrollToTop";
import Gha_ProfileInfo from "./Gha_ProfileInfo";
import { el } from "date-fns/locale";
import Gha_SelectAccount from "./Gha_SelectAccount";
import { getGhaProfileInfo } from "../../../action/gha";
import { validateGhaSelectedProfileLS, ghaAllProfilesLSKey, ghaSelectedProfileLSKey } from './index'





const Gha_Profile = (props) => {

    const [shouldRenderComponents, setShouldRenderComponents] = useState(false);
    const [switchingProfile, setSwitchingProfile] = useState(true);
    const [selectedProfileDetails, setSelectedProfileDetails] = useState(null)
    const [showLoader, setShowLoader] = useState(false);
    const [prevSelectedDetails, setPrevSelectedDetails] = useState(null)



    let widgetSesstionId = localStorage.getItem("ghaSessionToken");
    let label = getDefaultAnalyticsLabel({
        appVersion: props.installedAppVersion
            ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
            : "",
    });

    const sendAnalytic = (isSuccess, res) => {
        props.sendAnalytics(
            props.guestDetail,
            props.currentWidgets.widgetType,
            `Login response ${isSuccess ? 'Success' : "failed"}`,
            {
                ...label,
                layoutTab: props.currentHomePage.tabName,
                element: "widget",
                widgetSessionId: widgetSesstionId,
                errorStatus: JSON.stringify(res),
                errorMessage: JSON.stringify(
                    res
                ),
            },
            0,
            props.guestIsLoggedIn
        );
    }


    const { t } = props;


    const handleSelectProfile = async (profile) => {
        try {
            console.log("called handleSelectProfile", profile)
            const payload = {
                "username": "", //Keep "" always.
                "password": "", // Keep "" always.
                "profileId": profile.profileId, //Required, read from Login response.
                "firstName": profile.firstName, //Required, read from Login response.
                "lastName": profile.lastName //Required, read from Login response.
            }


            setShowLoader(true);
            let result;

            const response = await getGhaProfileInfo(payload);

            if (response.status == 200) {
                console.log("got successful response 200 from getProfile", response.data)
                result = response.data;
                // localStorage.setItem(ghaSelectedProfileLSKey, JSON.stringify(profile));
                // setSelectedProfileDetails(res.data);
                // setSwitchingProfile(false);
                setShowLoader(false);
            } else {
                setShowLoader(false);
                sendAnalytic(false,response)
                throw new Error()
            }




            return result;
        } catch {
            sendAnalytic(false)
            throw new Error()
        }
    }



    const handleBack = () => {

        if (switchingProfile) {
            if (prevSelectedDetails) {
                const data = prevSelectedDetails
                setSelectedProfileDetails(data);
                setSwitchingProfile(false);
                setPrevSelectedDetails(null)
            }
            else {
                setPrevSelectedDetails(null);
                props.setGoHome(true)
            }

        }
        else {
            props.setGoHome(true)
        }


    }
    // const handleSwitchProfile = () => {
    //     setSwitchingProfile(true)
    // }


    const startFlow = async () => {

        try {
            if (props.allProfilesData && props.allProfilesData.length == 1) {
                console.log("selecting only option of allProfilesData", props.allProfilesData)

                const profile = await handleSelectProfile(props.allProfilesData[0]);
                localStorage.setItem(ghaSelectedProfileLSKey, JSON.stringify(props.allProfilesData[0]));
                setSelectedProfileDetails(profile);
                setSwitchingProfile(false);


                return;
            }

            if (validateGhaSelectedProfileLS()) {
                console.log("using localStorage ghaSelectedProfile", JSON.parse(localStorage.getItem(ghaSelectedProfileLSKey)))

                const response = await handleSelectProfile(JSON.parse(localStorage.getItem(ghaSelectedProfileLSKey)))
                setSelectedProfileDetails(response);
                setSwitchingProfile(false);

                return;
            }
        }
        catch {
            localStorage.removeItem(ghaSelectedProfileLSKey)
            setSwitchingProfile(true);

        }
    }

    const handleSelectProfileFromSelectAccount = async (profile) => {

        try {
            const response = await handleSelectProfile(profile);
            localStorage.setItem(ghaSelectedProfileLSKey, JSON.stringify(profile));
            setSelectedProfileDetails(response);
            setPrevSelectedDetails(null);
            setSwitchingProfile(false);

        } catch {
            // localStorage.removeItem(ghaSelectedProfileLSKey)
            localStorage.removeItem(ghaAllProfilesLSKey)
            setPrevSelectedDetails(null);

            props.handleLogoutUser();

        }
    }

    const handleSwitchClick = () => {
        setPrevSelectedDetails(selectedProfileDetails);
        setSwitchingProfile(true);
    }

    useEffect(async () => {

        scrollToTop();

        console.log("starting flow....")
        await startFlow();
        console.log("changing setShouldRenderComponents ....")
        setShouldRenderComponents(true);

    }, []);

    useEffect(() => {
        console.log('switchingProfile is ', switchingProfile)
    }, [switchingProfile])




    return (
        <>
            {
                (!shouldRenderComponents || showLoader)

                    ?

                    <Loader />
                    :
                    (
                        switchingProfile
                            ? <Gha_SelectAccount handleSelectProfileFromSelectAccount={handleSelectProfileFromSelectAccount} allProfilesData={props.allProfilesData} handleBack={handleBack} handleLogoutUser={props.handleLogoutUser} requiredLinks={props.requiredLinks} />
                            : <Gha_ProfileInfo selectedProfileDetails={selectedProfileDetails} allProfilesData={props.allProfilesData} handleSwitchClick={handleSwitchClick} handleBack={handleBack} handleLogoutUser={props.handleLogoutUser} requiredLinks={props.requiredLinks}/>

                    )

            }
        </>

    );
};

const mapStateToProps = (state) => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
        dateFormat: state.store.home.clientConfig.extraConfigParam
            ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
            : "",
        logo: state.store.home.currentDuration.brandingInfo
            ? state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl
            : "",

    };
};

export default connect(mapStateToProps, { setGoHome, closeOrderPopUp, sendAnalytics })(
    withTranslation("translations")(Gha_Profile)
);